import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (error.name === 'ChunkLoadError' || error.message.includes('Loading chunk')) {
      window.location.reload();
      return;
    }

    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
          <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow-xl border border-gray-100 text-center">
            <div className="text-6xl mb-4 animate-bounce">🛠️</div>
            <h2 className="text-2xl font-extrabold text-gray-800 mb-2">अरे नहीं! कुछ गलत हो गया 😥</h2>
            <p className="text-gray-500 font-medium mb-6 text-sm leading-relaxed">
              हम एक तकनीकी समस्या का सामना कर रहे हैं। हमारी टीम इसे जल्द ही ठीक कर देगी। कृपया पेज को रीफ्रेश करके दोबारा प्रयास करें।
            </p>
            <button
              onClick={() => window.location.reload()}
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-4 rounded-xl transition-all shadow-md flex items-center justify-center gap-2"
            >
              🔄 पेज रीफ्रेश करें
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;